import { render, staticRenderFns } from "./BullettinManualModal.vue?vue&type=template&id=7ae935c2&"
import script from "./BullettinManualModal.vue?vue&type=script&lang=js&"
export * from "./BullettinManualModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports